import { render } from "./AppFooter.vue?vue&type=template&id=c3220d84&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=c3220d84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3220d84"],['__file',"src/core/layout/AppFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3220d84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3220d84', __exports__)) {
    console.log('reload')
    api.reload('c3220d84', __exports__)
  }
  
  module.hot.accept("./AppFooter.vue?vue&type=template&id=c3220d84&scoped=true", () => {
    console.log('re-render')
    api.rerender('c3220d84', render)
  })

}


export default __exports__